import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa2dc25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "measurements-selector__sub-section" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "measurements-selector__menu" }
const _hoisted_4 = {
  key: 0,
  class: "input-container"
}
const _hoisted_5 = { class: "drill-hole-inputs" }

import {computed, onBeforeUnmount, onMounted } from "vue";
import { useStore } from "vuex";
import Length from "../../../source/js/shared/models/Geometry/Length";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ValidationMessage from "@/components/UI/ValidationMessage.vue";
import {formatForInputField, endsWithSeparator, stripNonNumeric} from "@/functions/numbers";
import {addSizeToDataLayer} from "@/functions/analytics";
import DrillHoleConfigurationFactory from "@/Models/DrillHoleConfigurations/DrillHoleConfigurationFactory";
import DrillHoleEdgeTypeCorner from "@/components/icons/DrillHoleEdgeTypeCorner.vue";
import DrillHoleEdgeTypeAround from "@/components/icons/DrillHoleEdgeTypeAround.vue";
import DrillHoleEdgeTypeTopBottom from "@/components/icons/DrillHoleEdgeTypeTopBottom.vue";
import DrillHoleEdgeTypeLeftRight from "@/components/icons/DrillHoleEdgeTypeLeftRight.vue";
import DrillHoleEdgeCounts from "@/components/DrillHoleEdgeCounts.vue";
import MessageContainer from "@/components/UI/MessageContainer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DrillHoleEdgeTypes',
  setup(__props) {

const store = useStore();

const isDrillHoleValid = computed(() => store.getters.isDrillHoleValid );
const getDrillHoleValidationMessage = computed(() => store.getters.getDrillHoleValidationMessage );
const minimumDrillHoleDiameter = computed(() => store.getters.minimumDrillHoleDiameter );
const lastGeneratedConfiguration = computed(() => store.getters.lastGeneratedConfiguration );
const drillHoleEdgeType = computed(() => store.getters.drillHoleEdgeType );
const drillHoleTypeEnabled = computed(() => store.getters.drillHoleTypeEnabled );
const getEdgeCount = computed(() => store.getters.getEdgeCount );
const drillOption = computed(() => store.getters.drillOption );

const drillHoleOffset = computed({
	get: () => formatForInputField( store.getters.drillHoleOffset.in_cm() ),
	set: (value: string) => {
		if ( ! endsWithSeparator( value ) && value !== '' ) {
			store.commit( 'updateDrillHoleOffset', Length.from_cm( stripNonNumeric( value ) ).in_mm() );
			store.commit( 'updateUsingDefaultDrillHoleDimensions', false );
		}
	},
});
const drillHoleDiameter = computed({
	get: () => formatForInputField( store.getters.drillHoleDiameter.in_cm() ),
	set: (value: string) => {
		if ( ! endsWithSeparator( value ) && value !== '' ) {
			store.commit( 'updateDrillHoleDiameter', Length.from_cm( stripNonNumeric( value ) ).in_mm() );
			store.commit( 'updateUsingDefaultDrillHoleDimensions', false );
		}
	},
});

document.addEventListener("focusin", focusChanged);

function focusChanged(event): void {
	store.commit("updateFocusedElement", event.target);
}

function drillHoleFieldsWithMessage(): {key: string, message: string}[] {
	const configuration = new DrillHoleConfigurationFactory().get_configuration( 'edge' );

	// filter out keys with valid dimensions
	const invalidKeys = configuration.get_input_keys().filter((field) => !isDrillHoleValid.value(field));

	// get the data we need to render a notice
	return invalidKeys.map((field) => {
		return {
			key: field,
			message: getDrillHoleValidationMessage.value(field),
		};
	});
}

onMounted(async () => {

	// Don't set defaults if we have an old configuration available for radial drill holes.
	if ( lastGeneratedConfiguration.value.drillholes?.type === 'edges' ) {
		return;
	}
});

onBeforeUnmount(() => {
	document.removeEventListener("focusin", focusChanged);
});

function updateDrillHoleEdgeType( type: string ) {
	store.commit( 'updateDrillHoleEdgeType', type );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$i18n.drillHolesChoosePosition), 1),
      _createElementVNode("div", _hoisted_3, [
        (drillHoleTypeEnabled.value('corners'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {updateDrillHoleEdgeType('corners');}),
              class: _normalizeClass({
						"measurements-selector__menu-button": true,
						"measurements-selector__menu-button--wide": true,
						"measurements-selector__menu-button-drill-edge-type-corners": true,
						"measurements-selector__menu-button--active": drillHoleEdgeType.value === "corners",
					})
            }, [
              _createVNode(DrillHoleEdgeTypeCorner, { alt: "" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$i18n.drillHoleEdgeTypes.corners), 1)
            ], 2))
          : _createCommentVNode("", true),
        (drillHoleTypeEnabled.value('around'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {updateDrillHoleEdgeType('around');}),
              class: _normalizeClass({
						"measurements-selector__menu-button": true,
						"measurements-selector__menu-button--wide": true,
						"measurements-selector__menu-button-drill-edge-type-around": true,
						"measurements-selector__menu-button--active": drillHoleEdgeType.value === "around",
					})
            }, [
              _createVNode(DrillHoleEdgeTypeAround, { alt: "" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$i18n.drillHoleEdgeTypes.around), 1)
            ], 2))
          : _createCommentVNode("", true),
        (drillHoleTypeEnabled.value('top_bottom'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {updateDrillHoleEdgeType('top_bottom');}),
              class: _normalizeClass({
						"measurements-selector__menu-button": true,
						"measurements-selector__menu-button--wide": true,
						"measurements-selector__menu-button-drill-edge-type-top_bottom": true,
						"measurements-selector__menu-button--active": drillHoleEdgeType.value === "top_bottom",
					})
            }, [
              _createVNode(DrillHoleEdgeTypeTopBottom, { alt: "" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$i18n.drillHoleEdgeTypes.top_bottom), 1)
            ], 2))
          : _createCommentVNode("", true),
        (drillHoleTypeEnabled.value('left_right'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {updateDrillHoleEdgeType('left_right');}),
              class: _normalizeClass({
						"measurements-selector__menu-button": true,
						"measurements-selector__menu-button--wide": true,
						"measurements-selector__menu-button-drill-edge-type-left_right": true,
						"measurements-selector__menu-button--active": drillHoleEdgeType.value === "left_right",
					})
            }, [
              _createVNode(DrillHoleEdgeTypeLeftRight, { alt: "" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$i18n.drillHoleEdgeTypes.left_right), 1)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    (drillHoleEdgeType.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(DimensionInput, {
              inputRef: "drillHoleOffset",
              id: "drillHoleOffset",
              name: "drillHoleOffset",
              inputmode: "decimal",
              unit: "cm",
              label: _ctx.$i18n.drillHoleConfiguration.distance_from_edge,
              invalid: !isDrillHoleValid.value('drillHoleOffset'),
              onBlur: () => _unref(addSizeToDataLayer)(_ctx.$i18n.drillHoleConfiguration.distance_from_edge, drillHoleOffset.value, 'drill-hole-offset'),
              modelValue: drillHoleOffset.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((drillHoleOffset).value = $event))
            }, null, 8, ["label", "invalid", "onBlur", "modelValue"]),
            _createVNode(DimensionInput, {
              inputRef: "drillHoleDiameter",
              id: "drillHoleDiameter",
              name: "drillHoleDiameter",
              inputmode: "decimal",
              unit: "cm",
              min: minimumDrillHoleDiameter.value,
              label: `${_ctx.$i18n.drillHoleConfiguration.diameter_drill_hole}`,
              invalid: !isDrillHoleValid.value('drillHoleDiameter'),
              onBlur: () => _unref(addSizeToDataLayer)(_ctx.$i18n.drillHoleConfiguration.diameter_drill_hole, drillHoleDiameter.value, 'drill-hole-diameter'),
              modelValue: drillHoleDiameter.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((drillHoleDiameter).value = $event))
            }, null, 8, ["min", "label", "invalid", "onBlur", "modelValue"]),
            (drillHoleTypeEnabled.value('around') && drillHoleEdgeType.value === 'around' && getEdgeCount.value)
              ? (_openBlock(), _createBlock(DrillHoleEdgeCounts, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(MessageContainer, null, {
            default: _withCtx(() => [
              (drillOption.value !== 'none')
                ? (_openBlock(), _createBlock(ValidationMessage, {
                    key: 0,
                    type: "notice"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$i18n.drillHolesNotice), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drillHoleFieldsWithMessage(), (field) => {
                return (_openBlock(), _createBlock(ValidationMessage, {
                  key: field.key + '-validation-message',
                  "input-id": field.key
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(field.message), 1)
                  ]),
                  _: 2
                }, 1032, ["input-id"]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})